<div class="generic-table--sort-header-outer">
  @switch (columnType) {
    @case ('hierarchy') {
      <span class="generic-table--sort-header">
        @if (displayHierarchyIcon) {
          <span
            class="hierarchy-header--icon"
            (click)="toggleHierarchy($event)"
            [attr.title]="text.toggleHierarchy"
            tabindex="-1"
            aria-hidden="true">
            <op-icon icon-classes="icon {{ hierarchyIcon }}" />
          </span>
        }
        <!--suppress XmlDuplicatedId -->
        @if (sortable) {
          <a href="#"
            [ngClass]="[directionClass && 'sort', directionClass]"
            lang-attribute
            lang="{{locale}}"
            id="{{ headerColumn.id }}"
          rel="nofollow">{{headerColumn.name}}</a>
        }
        @if (!sortable) {
          <a>{{headerColumn.name}}</a>
        }
        @if (displayDropdownIcon) {
          <op-icon icon-classes="dropdown-indicator icon-small icon-pulldown"
            icon-title="{{ text.openMenu }}"
           />
        }
      </span>
    }
    @case ('relation') {
      <span class="generic-table--sort-header">
        <a [attr.title]="headerColumn.name">
          <op-icon icon-classes="icon-context icon-relations relations-header--icon" />
          {{columnName}}
        </a>
        @if (displayDropdownIcon) {
          <op-icon icon-classes="dropdown-indicator icon-small icon-pulldown"
            icon-title="{{ text.openMenu }}"
           />
        }
      </span>
    }
    @case ('sort') {
      <span class="draggable-table--sort-header"
        >
      </span>
    }
    @default {
      <span class="generic-table--sort-header">
        <!--suppress XmlDuplicatedId -->
        @if (sortable) {
          <a href="#"
            [ngClass]="[directionClass && 'sort', directionClass]"
            lang-attribute
            lang="{{locale}}"
            id="{{ headerColumn.id }}"
          rel="nofollow">{{headerColumn.name}}</a>
        }
        @if (!sortable) {
          <a>{{headerColumn.name}}</a>
        }
        @if (baselineIncompatible) {
          <span
            class="generic-table--sort-header--error-indicator"
            [attr.title]="text.baselineIncompatible"
            >
            <svg alert-icon size="small"></svg>
          </span>
        }
        @if (displayDropdownIcon) {
          <op-icon icon-classes="dropdown-indicator icon-small icon-pulldown"
            icon-title="{{ text.openMenu }}"
           />
        }
      </span>
    }
  }
</div>
